import axios from 'axios';
import { FreezeYear, GrossDemandDeterminationTotalCreate, GrossDemandDeterminationTotalUpdate } from './update';
export {grossDemandActions};

axios.defaults.withCredentials = true

export interface UpdatePercentage{
    id:number;
    percentageToUpdate:number;
  }

  export interface ResetYearPercentage{
    yearToReset:number;
  }

  export interface ResetPercentage{
    id:number;
  }
  

function grossDemandActions() {
    const baseUrl = ``;
    const tenantVal = `${process.env.REACT_APP_TENANT}`;
  
    return {
        getAll,
        update,
        freezeYear,
        unfreezeYear,
        create,
        getSegmentDemandDetermination,
       // exportData,
        exportSegmentDemandDetermination,
        updatePercentageSegmentDemandDetermination,
        resetYearsPercentage,
        resetPercentage,
        getAggregations    
    }

    async function update(tenant: string, grossDemandDeterminationTotalUpdate:GrossDemandDeterminationTotalUpdate) {
        return axios.put(`${baseUrl}/fleetplanning/grossdemanddetermination/update`,
        grossDemandDeterminationTotalUpdate, {params:{tenant:tenant}});
    }

    async function getAll(tenant: string, yearFrom: number, yearTo: number,monthFrom: number, monthTo: number, aggregation: string) {
        const getAllGrossDemandDetermination = await axios.get(`${baseUrl}/fleetplanning/grossdemanddetermination`, { 
        params: {
            tenant: tenant,
            yearFrom: yearFrom, 
            yearTo: yearTo,
            monthFrom: monthFrom,
            monthTo: monthTo,
            aggregation: aggregation
        }, 
        headers: {}, 
    })
        return getAllGrossDemandDetermination.data

    }

    async function freezeYear(tenant: string, freezeYearsObject:FreezeYear) {
        return new Promise(function (resolve, reject) {
            axios.put(`${baseUrl}/fleetplanning/grossdemanddetermination/freezeyear`, freezeYearsObject, {params:{tenant:tenant}},
            ).then(function (response) {
                resolve(response.data);
            });
        });

    }

    async function unfreezeYear(tenant: string, yearToUnfreeze:number) {
        return new Promise(function (resolve, reject) {
            axios.put(`${baseUrl}/fleetplanning/grossdemanddetermination/unfreezeyear?tenant=`+tenant+`&yearToUnfreeze=`+yearToUnfreeze, {},
            ).then(function (response) {
                resolve(response.data);
            });
        });

    }

    async function create(tenant: string, createCellObject:GrossDemandDeterminationTotalCreate[]) {
        return axios.post(`${baseUrl}/fleetplanning/grossdemanddetermination/create`, createCellObject, {params:{tenant:tenant}})

    }
    

   

    async function getSegmentDemandDetermination( tenant: string, yearFrom: number, yearTo: number,
        monthFrom: number, monthTo: number) {

            const getAllSegmentDemandDetermination = await axios.get(`${baseUrl}/fleetplanning/segmentdemanddetermination`, { 
                    params: {
                        tenant: tenant,
                        yearFrom: yearFrom, 
                        yearTo: yearTo,
                        monthFrom: monthFrom,
                        monthTo: monthTo},
                    headers:{}
                 }
                )

                return getAllSegmentDemandDetermination.data;

        }

    async function exportSegmentDemandDetermination(tenant: string, year: number,changeURL:any){   
        const params = { tenant: tenant, year: year};
        return   axios.get(`${baseUrl}/fleetplanning/${changeURL}`, { params,
                responseType: 'arraybuffer',
                headers: { 'Access-Control-Allow-Origin': true },
             }
            )
    }

    async function updatePercentageSegmentDemandDetermination(tenant: string, updatePercentage:any){   
        return   axios.put(`${baseUrl}/fleetplanning/segmentdemanddetermination/updatepercentage`, updatePercentage, {params:{tenant:tenant}}
            )
    }

    async function resetYearsPercentage(tenant: string, resetYearsPercentage:any){
        return axios.put(`${baseUrl}/fleetplanning/segmentdemanddetermination/resetyearpercentage`,resetYearsPercentage, {params:{tenant:tenant}})
    }

    async function resetPercentage(tenant: string, resetPercentage:any){
        return axios.put(`${baseUrl}/fleetplanning/segmentdemanddetermination/resetpercentage`,resetPercentage, {params:{tenant:tenant}})
    }

    async function getAggregations(tenant: string) {
        const getAggregations = await axios.get(`${baseUrl}/fleetplanning/grossdemanddetermination/aggregations`, {params:{tenant:tenant}} 
    )
        return getAggregations.data

    }

}
